import type { MapTemplateType } from '@/types/MapTemplate';

/**
 * 외부 플랫폼 환경에서 허용되는 맵 템플릿 타입.
 * allowlist 방식 — 새로운 타입 추가 시 명시적으로 여기에 포함해야 표시됨.
 */
export const EXTERNAL_PLATFORM_ALLOWED_TEMPLATE_TYPES: MapTemplateType[] = [
  'linear',
  'free',
];
